// @flow
import createCollectionReducer from './createCollectionReducer';

export type State = {|
  +loading: boolean,
  +loaded: boolean,
  +loadedCursors: { [key: string]: boolean },
  +entities: Array<string>,
|};

const initialState: State = {
  loading: false,
  loaded: false,
  loadedCursors: {},
  entities: [],
};

const playlistCollectionActions = {
  add: 'ADD_PLAYLIST_TO_COLLECTION',
  remove: 'REMOVE_PLAYLIST_FROM_COLLECTION',
  fetch: 'FETCH_PLAYLIST_COLLECTION',
};

export default createCollectionReducer(initialState, playlistCollectionActions);
